// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Drawing Dock Styles - CSS Module */
.cZH_uIaQB_N2Sw66a6J7 {
  position: absolute;
  z-index: 50;
  width: 360px;
  min-height: 200px;
  max-height: 500px;
  background: var(--vnsc-bg-secondary, #111820);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: var(--vnsc-radius-lg, 6px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  font-family: var(--gc-font, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif);
  font-size: var(--vnsc-font-sm, 11px);
  color: var(--vnsc-text-primary, #e0e0e0);
}

.husjPzRt8u2JIBJz72vO {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-primary, #0a0e14);
  border-radius: var(--vnsc-radius-lg, 6px) var(--vnsc-radius-lg, 6px) 0 0;
}

.DgideiBBWn34EwdL1yVM {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.DgideiBBWn34EwdL1yVM strong {
  font-size: 12px;
  font-weight: 600;
  color: var(--vnsc-text-primary);
}

.DgideiBBWn34EwdL1yVM span {
  font-size: 10px;
  color: var(--vnsc-text-secondary);
}

.J4tS59Jm3wvGwvjBKHUR {
  display: flex;
  align-items: center;
  gap: 4px;
}

.uO7g7doa_shzbfcl8inE {
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.uO7g7doa_shzbfcl8inE:hover {
  background-color: var(--vnsc-bg-tertiary, #f1f5f9);
  color: var(--vnsc-text-primary);
}

.RePsUmT4yosvtNa6CFUx {
  display: flex;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-primary, #0a0e14);
}

.xzQ815Af9Odpvx51psWd {
  flex: 1;
  padding: 8px 12px;
  border: none;
  background: transparent;
  color: var(--vnsc-text-secondary);
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
}

.xzQ815Af9Odpvx51psWd:hover {
  color: var(--vnsc-text-primary);
  background-color: var(--vnsc-bg-tertiary, #f1f5f9);
}

.TlDc_wxE8U47wObGlcN2 {
  color: var(--vnsc-accent, #2962ff);
  border-bottom-color: var(--vnsc-accent, #2962ff);
}

.iqlSvrwmd76mDgpLCQhp {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}

.aAlfDiPPlY7fa4MY2ZG_ {
  color: var(--vnsc-text-secondary);
  font-style: italic;
  text-align: center;
  padding: 20px;
}

.BEwKn9LOKAAGYR7ABT96 {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 18px;
  height: 18px;
  cursor: nwse-resize;
  background: linear-gradient(
    135deg,
    transparent 0%,
    transparent 40%,
    var(--vnsc-text-secondary, #888) 40%,
    var(--vnsc-text-secondary, #888) 44%,
    transparent 44%,
    transparent 56%,
    var(--vnsc-text-secondary, #888) 56%,
    var(--vnsc-text-secondary, #888) 60%,
    transparent 60%
  );
  opacity: 0.4;
  transition: opacity 0.15s ease;
  border-radius: 0 0 var(--vnsc-radius-lg, 6px) 0;
  z-index: 1;
}

.BEwKn9LOKAAGYR7ABT96:hover {
  opacity: 0.8;
}

@media (max-width: 480px) {
  .cZH_uIaQB_N2Sw66a6J7 {
    width: calc(100vw - 32px);
    max-width: 360px;
  }
}

.fCvCDcKATwK9VchQ9MAb {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.DvUjow6ZBKWthOlEPxQ_ {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.v4395zuRvgxyceIcnPhe {
  font-size: 11px;
  font-weight: bold;
  color: var(--vnsc-text-secondary, #888);
}

.YFHdNzMqfmfhmaRFCUdN {
  display: flex;
  gap: 6px;
}

.CT3cxm_4JZ254A5BDEyb,
.GYa5bwvvDST3Ixjv9wlQ {
  flex: 0 1 200px;
  min-width: 120px;
  background: var(--vnsc-surface-raised, rgba(30, 41, 59, 0.9));
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.1));
  border-radius: 4px;
  padding: 6px 8px;
  color: var(--vnsc-text-primary, #fff);
  font-size: 12px;
}

.qfzjKqEzRgKNXiF615fS {
  background: var(--vnsc-accent, #0891b2);
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  color: var(--vnsc-text-primary, #fff);
  font-size: 12px;
  cursor: pointer;
}

.HxH8XB0DrbJN4Py5dsLB {
  background: var(--vnsc-danger, #ef5350);
}

.qfzjKqEzRgKNXiF615fS:disabled,
.HxH8XB0DrbJN4Py5dsLB:disabled {
  background: var(--vnsc-surface-muted, rgba(255, 255, 255, 0.05));
  color: var(--vnsc-text-disabled, #666);
  cursor: default;
}

.lRXdvSBqlgbx_LjRK7Uy {
  height: 1px;
  background: var(--vnsc-border-subtle, rgba(255, 255, 255, 0.08));
  margin: 4px 0;
}`, "",{"version":3,"sources":["webpack://./src/widget/styles/drawing-dock.module.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,6CAA6C;EAC7C,6CAA6C;EAC7C,yCAAyC;EACzC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,8FAA8F;EAC9F,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,oDAAoD;EACpD,2CAA2C;EAC3C,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yDAAyD;AAC3D;;AAEA;EACE,kDAAkD;EAClD,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,2CAA2C;AAC7C;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yDAAyD;EACzD,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kDAAkD;AACpD;;AAEA;EACE,kCAAkC;EAClC,gDAAgD;AAClD;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB;;;;;;;;;;;GAWC;EACD,YAAY;EACZ,8BAA8B;EAC9B,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,yBAAyB;IACzB,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,8DAA8D;EAC9D,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,gEAAgE;EAChE,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gEAAgE;EAChE,aAAa;AACf","sourcesContent":["/* Drawing Dock Styles - CSS Module */\r\n.dock {\r\n  position: absolute;\r\n  z-index: 50;\r\n  width: 360px;\r\n  min-height: 200px;\r\n  max-height: 500px;\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: var(--vnsc-radius-lg, 6px);\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\r\n  display: flex;\r\n  flex-direction: column;\r\n  font-family: var(--gc-font, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif);\r\n  font-size: var(--vnsc-font-sm, 11px);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 8px 12px;\r\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n  background: var(--vnsc-bg-primary, #0a0e14);\r\n  border-radius: var(--vnsc-radius-lg, 6px) var(--vnsc-radius-lg, 6px) 0 0;\r\n}\r\n\r\n.titleBlock {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.titleBlock strong {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: var(--vnsc-text-primary);\r\n}\r\n\r\n.titleBlock span {\r\n  font-size: 10px;\r\n  color: var(--vnsc-text-secondary);\r\n}\r\n\r\n.headerActions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.icon {\r\n  width: 24px;\r\n  height: 24px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary);\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  transition: background-color 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.icon:hover {\r\n  background-color: var(--vnsc-bg-tertiary, #f1f5f9);\r\n  color: var(--vnsc-text-primary);\r\n}\r\n\r\n.tabs {\r\n  display: flex;\r\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n  background: var(--vnsc-bg-primary, #0a0e14);\r\n}\r\n\r\n.tab {\r\n  flex: 1;\r\n  padding: 8px 12px;\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary);\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: color 0.15s ease, background-color 0.15s ease;\r\n  border-bottom: 2px solid transparent;\r\n  margin-bottom: -1px;\r\n}\r\n\r\n.tab:hover {\r\n  color: var(--vnsc-text-primary);\r\n  background-color: var(--vnsc-bg-tertiary, #f1f5f9);\r\n}\r\n\r\n.tabActive {\r\n  color: var(--vnsc-accent, #2962ff);\r\n  border-bottom-color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 12px;\r\n}\r\n\r\n.empty {\r\n  color: var(--vnsc-text-secondary);\r\n  font-style: italic;\r\n  text-align: center;\r\n  padding: 20px;\r\n}\r\n\r\n.resizeHandle {\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 0;\r\n  width: 18px;\r\n  height: 18px;\r\n  cursor: nwse-resize;\r\n  background: linear-gradient(\r\n    135deg,\r\n    transparent 0%,\r\n    transparent 40%,\r\n    var(--vnsc-text-secondary, #888) 40%,\r\n    var(--vnsc-text-secondary, #888) 44%,\r\n    transparent 44%,\r\n    transparent 56%,\r\n    var(--vnsc-text-secondary, #888) 56%,\r\n    var(--vnsc-text-secondary, #888) 60%,\r\n    transparent 60%\r\n  );\r\n  opacity: 0.4;\r\n  transition: opacity 0.15s ease;\r\n  border-radius: 0 0 var(--vnsc-radius-lg, 6px) 0;\r\n  z-index: 1;\r\n}\r\n\r\n.resizeHandle:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .dock {\r\n    width: calc(100vw - 32px);\r\n    max-width: 360px;\r\n  }\r\n}\r\n\r\n.templateManager {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.templateGroup {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.templateLabel {\r\n  font-size: 11px;\r\n  font-weight: bold;\r\n  color: var(--vnsc-text-secondary, #888);\r\n}\r\n\r\n.templateRow {\r\n  display: flex;\r\n  gap: 6px;\r\n}\r\n\r\n.templateSelect,\r\n.templateInput {\r\n  flex: 0 1 200px;\r\n  min-width: 120px;\r\n  background: var(--vnsc-surface-raised, rgba(30, 41, 59, 0.9));\r\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.1));\r\n  border-radius: 4px;\r\n  padding: 6px 8px;\r\n  color: var(--vnsc-text-primary, #fff);\r\n  font-size: 12px;\r\n}\r\n\r\n.templateButton {\r\n  background: var(--vnsc-accent, #0891b2);\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding: 6px 12px;\r\n  color: var(--vnsc-text-primary, #fff);\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.templateButtonDanger {\r\n  background: var(--vnsc-danger, #ef5350);\r\n}\r\n\r\n.templateButton:disabled,\r\n.templateButtonDanger:disabled {\r\n  background: var(--vnsc-surface-muted, rgba(255, 255, 255, 0.05));\r\n  color: var(--vnsc-text-disabled, #666);\r\n  cursor: default;\r\n}\r\n\r\n.templateDivider {\r\n  height: 1px;\r\n  background: var(--vnsc-border-subtle, rgba(255, 255, 255, 0.08));\r\n  margin: 4px 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dock": `cZH_uIaQB_N2Sw66a6J7`,
	"header": `husjPzRt8u2JIBJz72vO`,
	"titleBlock": `DgideiBBWn34EwdL1yVM`,
	"headerActions": `J4tS59Jm3wvGwvjBKHUR`,
	"icon": `uO7g7doa_shzbfcl8inE`,
	"tabs": `RePsUmT4yosvtNa6CFUx`,
	"tab": `xzQ815Af9Odpvx51psWd`,
	"tabActive": `TlDc_wxE8U47wObGlcN2`,
	"body": `iqlSvrwmd76mDgpLCQhp`,
	"empty": `aAlfDiPPlY7fa4MY2ZG_`,
	"resizeHandle": `BEwKn9LOKAAGYR7ABT96`,
	"templateManager": `fCvCDcKATwK9VchQ9MAb`,
	"templateGroup": `DvUjow6ZBKWthOlEPxQ_`,
	"templateLabel": `v4395zuRvgxyceIcnPhe`,
	"templateRow": `YFHdNzMqfmfhmaRFCUdN`,
	"templateSelect": `CT3cxm_4JZ254A5BDEyb`,
	"templateInput": `GYa5bwvvDST3Ixjv9wlQ`,
	"templateButton": `qfzjKqEzRgKNXiF615fS`,
	"templateButtonDanger": `HxH8XB0DrbJN4Py5dsLB`,
	"templateDivider": `lRXdvSBqlgbx_LjRK7Uy`
};
export default ___CSS_LOADER_EXPORT___;
